import React from 'react'
import { Container, IconContainer, Div } from './ModelSelectionButton.styles'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import Icon from '../Icon/Icon'
import { COLORS } from '../../constants'
import { Product } from '../../services/types/product'

type ModelSelectionButtonProps = {
  product: Product
  selectedProducts: Product[]
  setSelectedProducts: (products: Product[]) => void
}

const ModelSelectionButton: React.FC<ModelSelectionButtonProps> = ({
  product,
  selectedProducts,
  setSelectedProducts
}) => {
  const { partName, productNumber, leadTime } = product
  const isPartNumberAlreadySelected = selectedProducts.some(
    (selectedProduct) => selectedProduct.productNumber === productNumber
  )

  const handleProductClick = () => {
    console.log('=== PRODUCT CLICKED ===')
    console.log('Product being added:', product)
    console.log('Is already selected:', isPartNumberAlreadySelected)

    if (isPartNumberAlreadySelected) {
      console.log('Product already selected, skipping')
      return
    } else {
      console.log('Adding product to selected list with units initialized to 0')
      // Initialize product with units: 0 to ensure consistent calculation
      const productWithUnits = { ...product, units: 0 }
      setSelectedProducts([...selectedProducts, productWithUnits])
    }
  }

  return (
    <Container
      onClick={handleProductClick}
      $selected={false} //{isPartNumberAlreadySelected} <-- TO-ACTIVATE
    >
      <Div>
        {productNumber && (
          <p>
            Model #: <span>{productNumber}</span>
          </p>
        )}
        {partName && (
          <p>
            <span>{partName}</span>
          </p>
        )}
        {leadTime && (
          <p>
            <span>{leadTime}</span>
          </p>
        )}
      </Div>

      <IconContainer>
        {/*TO-ACTIVATE*/}
        {/*{!isPartNumberAlreadySelected && (*/}
        {/*  <Icon icon={faChevronRight} size="30px" color={COLORS.darkGray} />*/}
        {/*)}*/}
        <Icon icon={faChevronRight} size="30px" color={COLORS.darkGray} />
      </IconContainer>
    </Container>
  )
}

export default ModelSelectionButton
